import "stream-chat-react/dist/css/v2/index.css";
import { MessageCircleOff } from "lucide-react";
import { useTranslation } from "react-i18next";

import { Button } from "@/components/ui/button";
import { useMe } from "@/context/user-context";

import "./messages.css";
import { MessageClient } from "./message-client";
import { MessagesTeaser } from "./messages-teaser";

export function Messages() {
  const { streamUser, user } = useMe();
  // Un club freemium n'a pas de token StreamChat : le client ne peut pas se
  // connecter, on affiche une conversation factice de l'équipe Teamz à la place.
  const isFreemiumClub = user.role === "club" && !user.plan && !user.isAdmin;
  let content = <MessageClient />;

  if (isFreemiumClub) {
    content = <MessagesTeaser />;
  }
  if (streamUser.unavailable) {
    content = <MessagesUnavailable />;
  }

  return (
    <div className="flex h-[calc(100svh-136px)] md:p-4 xl:h-screen">
      {content}
    </div>
  );
};

function MessagesUnavailable() {
  const { t } = useTranslation("common");

  return (
    <div className="flex w-full flex-col items-center justify-center gap-4 rounded-xl border border-neutral-300 bg-white p-6 text-center">
      <MessageCircleOff className="size-10 text-neutral-450" />
      <p className="max-w-md text-neutral-700">{t("chat-unavailable")}</p>
      <Button type="button" onClick={() => window.location.reload()}>
        {t("reload")}
      </Button>
    </div>
  );
}
